import { Close } from "@mui/icons-material"
import { Tooltip } from "@mui/material"
import { IconButton, Typography } from "src/lib"
import { StyledAttachmentCard, StyledAttachmentHeader, StyledAttachmentBadge } from "./styled"

interface IAttachmentCardProps {
    filename: string
    typeLabel: string
    /** Not every source knows the file's size (e.g. older history entries) — shown next to typeLabel
     * only when present. */
    sizeBytes?: number
    /** Only the pre-send preview passes this — an already-sent attachment can't be removed. */
    onRemove?: () => void
}

/** Square file card shared by the compose bar's pre-send preview and an already-sent message's
 * attachment display — filename up top, file-type badge pinned to the bottom, same in both places. */
const AttachmentCard = ({ filename, typeLabel, sizeBytes, onRemove }: IAttachmentCardProps) => {
    const sizeLabel = sizeBytes != null ? `${(sizeBytes / (1024 * 1024)).toFixed(2)} MB` : undefined

    return (
        <Tooltip title={filename}>
            <StyledAttachmentCard>
                <StyledAttachmentHeader>
                    <Typography variant="body2" className="chat-attachment-filename">
                        {filename}
                    </Typography>
                    {onRemove && (
                        <IconButton variant="clean" color="neutral" size="small" onClick={onRemove}>
                            <Close fontSize="small" />
                        </IconButton>
                    )}
                </StyledAttachmentHeader>
                <StyledAttachmentBadge>
                    <Typography variant="caption" noWrap className="chat-attachment-badge-label">
                        {typeLabel}
                        {sizeLabel ? ` · ${sizeLabel}` : ""}
                    </Typography>
                </StyledAttachmentBadge>
            </StyledAttachmentCard>
        </Tooltip>
    )
}

export { AttachmentCard }
